<template>
    <div>
<!--        "<strong>{{ $_.get(activity, "refVisitor.fullname") }} </strong>" visitor was blocked by-->
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>-->
        <span v-html="$t('notification.visitorBlocked', { visitor: $_.get(activity, 'refVisitor.fullname'), agent:$_.get(activity, 'actorUser.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "VisitorBlocked",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
